import script from "./NavLink.vue?vue&type=script&setup=true&lang=js"
export * from "./NavLink.vue?vue&type=script&setup=true&lang=js"

export default script